import { Link, Navigate } from "react-router-dom";
import { PortalShell } from "@/components/AppHeader";
import { CardOnFile } from "@/components/CardOnFile";
import { useAuth } from "@/context/AuthContext";

export default function AddCardPage() {
  const { user } = useAuth();
  if (user.has_valid_card) return <Navigate to="/customer" replace />;
  return (
    <PortalShell>
      <div className="mx-auto max-w-xl space-y-6" data-testid="add-card-page">
        <div>
          <p className="lux-eyebrow">Step 2 of 2</p>
          <h1 className="mt-2 text-3xl font-semibold text-amber-50">Add your card</h1>
          <p className="mt-2 text-sm text-zinc-400">Every rider keeps one valid credit or debit card on file. You'll only be charged for rides you confirm and items you ask us to buy.</p>
        </div>
        <CardOnFile />
        <p className="text-xs text-zinc-500" data-testid="add-card-legal-links">See our <Link to="/terms" className="text-amber-300">Terms of Service</Link> and <Link to="/privacy" className="text-amber-300">Privacy Policy</Link>.</p>
      </div>
    </PortalShell>
  );
}
